import { render, staticRenderFns } from "./ApMain.vue?vue&type=template&id=f895ddc2"
import script from "./ApMain.vue?vue&type=script&lang=js"
export * from "./ApMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports